export class OrgManagementApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = "OrgManagementApiError";
  }
}
export function isManagementAuthorizationError(
  error: unknown,
): error is OrgManagementApiError {
  return (
    error instanceof OrgManagementApiError &&
    (error.status === 401 || error.status === 403)
  );
}

export function isManagementPageAccessError(
  error: unknown,
): error is OrgManagementApiError {
  return (
    isManagementAuthorizationError(error) ||
    (error instanceof OrgManagementApiError && error.status === 404)
  );
}

export async function readManagementJson<T>(response: Response): Promise<T> {
  const rawBody = await response.text();
  let body: {
    error?: unknown;
    reason?: unknown;
  } | null = null;

  try {
    body = rawBody ? JSON.parse(rawBody) : null;
  } catch {
    if (!response.ok) {
      throw new OrgManagementApiError(
        "management_request_failed",
        response.status,
      );
    }
    throw new Error("Response was not valid JSON.");
  }

  if (!response.ok) {
    const message =
      typeof body?.error === "string"
        ? body.error
        : typeof body?.reason === "string"
          ? body.reason
          : "management_request_failed";
    throw new OrgManagementApiError(message, response.status);
  }
  return body as T;
}
